/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

/**
 * Contact status.
 */
export type PatchContactRequestStatus = typeof PatchContactRequestStatus[keyof typeof PatchContactRequestStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchContactRequestStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
} as const;
